<template>
  <div class="task-container">
<!--    <van-search v-model="value" placeholder="请输入搜索关键词" />-->
    <div class="header-section" v-if="listData.length>0">
      <div class="pro-nums">
        <span class="label">项目数量</span>
        <span class="nums">{{result.length}}</span>
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="refresh-container">
      <van-list
        v-model="loading"
        :finished="finished"
        success-text="刷新成功"
        finished-text="没有更多了"
        @load="getList"
        :immediate-check="false"
      >
        <div v-for="(fa,i) in listData" :key="i">
          <div class="task-list" v-for="item in fa" :key="item.id" @click="taskInfo(item.id)">
            <div class="task-mid">
              <div class="task-header">
                <div class="task-title van-ellipsis">{{item.name}}</div>
                <div class="task-status" :class="{'status-active': item.status === 1, 'status-ended': item.status === 0}">
                  {{status[item.status]}}
                </div>
              </div>
              <div class="task-info">
                <div class="info-item">
                  <van-icon name="shop-o" />
                  <span>{{ displayMerchantName(item.merchantName) }}</span>
                </div>
                <div class="info-item">
                  <van-icon name="clock-o" />
                  <span>{{item.createTime}}</span>
                </div>
                <div class="info-item">
                  <van-icon name="gold-coin-o" />
                  <span>{{item.salaryRange}}</span>
                </div>
                <div class="info-item description">
                  <van-icon name="description" />
                  <span class="van-ellipsis">{{item.describe}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-empty description="暂无项目数据" v-if="!listData.length > 0" />
    <footer-menu></footer-menu>
  </div>
</template>
<script>
import footerMenu from '@/components/footer/FooterMenu'
import requestHTAPI from '@/axios/HantangTax'
export default {
  name: 'myPro',
  components: {
    footerMenu
  },
  data () {
    return {
      value: '',
      listData: [],
      result: [],
      loading: false,
      finished: false,
      refreshing: false,
      total: 0,
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      status: { 0: '结束', 1: '进行中' }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      requestHTAPI.mineProject({
        ...this.formData
      }).then(res => {
        this.loading = false
        if (res.data.code === '0000') {
          const data = res.data.data
          if (this.listData.length > 0 && data.pageNum === 1) {
            return
          }
          this.formData.pageNum = data.pageNum
          this.formData.pageNum++
          this.formData.pageSize = data.pageSize
          this.total = data.total
          this.listData.push(data.rows)
          this.result = Array.prototype.concat.apply([], this.listData)
          if (this.result.length >= this.total) {
            this.finished = true
            // this.$notify({ type: 'danger', message: '没有更多数据了' })
          }
        } else {
          this.finished = true
          this.$notify({ type: 'danger', message: res.data.message })
        }
      })
    },
    onRefresh () {
      // 清空列表数据
      if (this.refreshing) {
        this.formData.pageNum = 1
        this.listData = []
        this.refreshing = false
      }
      this.finished = false
      this.loading = true
      this.getList()
    },
    taskInfo (index) {
      this.$router.push({
        name: 'TaskInfo',
        query: {
          id: index,
          source: 'myPro'
        }
      })
    },
    displayMerchantName (name) {
      if (!name || typeof name !== 'string') return '*****公司'
      const suffixes = [
        '科技有限公司', '信息技术有限公司', '网络科技有限公司', '数据科技有限公司',
        '有限公司', '公司', '集团'
      ]
      const found = suffixes.find(s => name.endsWith(s))
      if (found) {
        const body = name.slice(0, name.length - found.length)
        const keep = body.slice(0, 2)
        return `${keep}***${found}`
      }
      return `${name.slice(0, 2)}***`
    }
  }
}
</script>
<style scoped lang="less">
  .task-container{
    height: calc(100% - 100px);
    background-color: #f5f7fa;
    padding-bottom: 20px;
  }

  .header-section {
    padding: 15px 20px;
    background: linear-gradient(to right, #4b6cb7, #182848);
    color: white;
    border-radius: 0 0 15px 15px;
    margin-bottom: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .refresh-container {
    padding-bottom: 60px;
  }

  .pro-nums{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;

    .label {
      font-weight: 500;
    }

    .nums{
      background-color: rgba(255, 255, 255, 0.2);
      color: white;
      border-radius: 20px;
      padding: 4px 14px;
      font-weight: bold;
      font-size: 18px;
    }
  }

  .task-list{
    background: #fff;
    overflow: hidden;
    margin: 0px 15px 15px;
    box-sizing: border-box;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    &:active {
      transform: scale(0.98);
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
    }
  }

  .task-mid{
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    text-align: left;
  }

  .task-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 10px;
  }

  .task-title {
    font-size: 26px;
    font-weight: bold;
    color: #333;
    flex: 1;
    padding-bottom: 5px;
  }

  .task-status {
    font-size: 18px;
    padding: 4px 14px;
    border-radius: 20px;
    font-weight: 500;

    &.status-active {
      background-color: rgba(25, 137, 250, 0.1);
      color: #1989fa;
    }

    &.status-ended {
      background-color: rgba(150, 151, 153, 0.1);
      color: #969799;
    }
  }

  .task-info {
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 20px;
      color: #333;

      .van-icon {
        margin-right: 10px;
        font-size: 22px;
        color: #666;
      }

      &.description {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px dashed #f0f0f0;
        font-size: 18px;
        line-height: 1.5;

        span {
          display: block;
          width: 100%;
        }
      }
    }
  }
</style>
